module.exports = __webpack_public_path__ + "static/media/album.8831183a.svg";